import * as Utils from '@/assets/js/Utils.js';

export class TagModel {

  public id: number | null = null;
  public name: string;
  public category: TagModel | null = null;
  public createdAt: Date | null;
  public visibility: number = 1;
  public color: string = '#ffc107';
  public tags: TagModel[] = [];

  public collapsed = false;
  public isEditing = false;

  constructor({
    id = null,
    name = '',
    category = null,
    createdAt = null,
    visibility = 1, // 0 = interne 1 = public
    color = '#000000',
    tags = [],
  }: {
    id?: number | null,
    name?: string,
    category?: any | null,
    createdAt?: Date | null,
    visibility?: number,
    color?: string,
    tags?: TagModel[],
  } = {}) {
    this.id = id;
    this.name = name;
    this.visibility = visibility;
    this.createdAt = createdAt;
    this.color = color;

    if (typeof category === 'number') {
      this.category = new TagModel({ id: category });
    } else if (category instanceof TagModel) {
      this.category = category;
    } else if (category && typeof category === 'object') {
      this.category = new TagModel(category);
    } else {
      this.category = null;
    }

    this.tags = tags.map((tag) =>
      new TagModel({
        id: tag.id ?? null,
        name: tag.name ?? '',
        category: this, // ✅ Correction : Assurer la référence parent
        createdAt: tag.createdAt ?? null,
        visibility: tag.visibility ?? 1,
        color: tag.color ?? '#ffc107',
        tags: tag.tags ?? [],
      })
    );
  }

  public toJSON(): any {
    return {
      id: this.id && this.id < 0 ? null : this.id,
      name: this.name,
      visibility: this.visibility,
      tags: this.tags.map(tag => tag.toJSON()),
      category: this.category ? this.category.id && this.category.id < 0 ? null : this.category.id : null,
      color: this.color,
    };
  }
  /*
    public toJSON(): any {
    return {
      id: this.id && this.id < 0 ? null : this.id, // Remplace les ID négatifs par null
      name: this.name,
      visibility: this.visibility,
      tags: this.tags.map(tag => tag.toJSON()), // Convertit récursivement les tags
      category: this.category, // Remplace ID négatif pour la catégorie
      color: this.color,
    };
  }
  */

  public get fullName(): string {
    if (this.category && this.category.name) {
      return this.category.name + ' - ' + this.name;
    }
    return this.name;
  }

  public get style(): string {
    let color = this.color;
    if (this.category) {
      color = this.category.color;
    }
    return `background-color:${color}; color:${this.textColor(color)}`;
  }

  private textColor(backgroundColor: string) {
    return Utils.getTextColor(backgroundColor);
  }
}

